import { apiRequest, putApiRequest } from './_tools';

export function fetchAccounts({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/accounts?page=${page}` +
    `&status=${filter.status}` +
    `&_id=${filter._id}` +
    `&externalId=${filter.externalId}` +
    `&email=${filter.email}` +
    `&website=${filter.website}` +
    `&companyName=${filter.companyName}` +
    `&country=${filter.country}` +
    `&itemsPerPage=${itemsPerPage}` +
    `&createdFrom=${filter.createDate.from}` +
    `&createdTo=${filter.createDate.to}` +
    `&isEmailConfirmed=${filter.isEmailConfirmed}` +
    `&isUsingSdk=${filter.isUsingSdk}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function updateAccount({ accountId, account }) {
  return putApiRequest(`/api/accounts/${accountId}`, account);
}

export function updateAccountStatus({ accountId, status }) {
  return putApiRequest(`/api/accounts/${accountId}/status/${status}`);
}

export function massUpdateAccountsStatuses({ accountsIds, status }) {
  return putApiRequest(`/api/accounts/mass/status/${status}`, { accountsIds });
}

export function sendEmailConfirmationMessage(accountId) {
  return apiRequest(`/api/sendEmailConfirmationMessage?accountId=${accountId}`);
}

export function updateIsEmailConfirmed({ accountId, isEmailConfirmed }) {
  return putApiRequest(`/api/accounts/${accountId}/isEmailConfirmed/${isEmailConfirmed}`);
}



/** WEBPACK FOOTER **
 ** ./js/core/api/accounts.js
 **/